import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  scoreScaleHint: {
    padding: theme.spacing(1, 1, 0, 1),
  },
}));

export default useStyles;
